import React from 'react';
import './ExportCSVButton.css';

interface ExportCSVButtonProps {
  data: object[];
  filename?: string;
  isFixed?: boolean;
}

const ExportCSVButton: React.FC<ExportCSVButtonProps> = ({
  data,
  filename = 'export.csv',
  isFixed = false,
}) => {
  const convertToCSV = (array: object[]): string => {
    if (array.length === 0) return '';

    const keys = Object.keys(array[0]);
    const csvRows = [keys.join(',')];

    for (const row of array) {
      const values = keys.map((key) => {
        const escaped = ('' + row[key as keyof typeof row]).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  };

  const downloadCSV = () => {
    const csvString = convertToCSV(data);
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <button
      className={`${
        isFixed ? 'download-button-fixed ' : ''
      }download-button material-icons`}
      onClick={downloadCSV}
    >
      download
    </button>
  );
};

export default ExportCSVButton;
